import React from 'react';
import { FiX } from 'react-icons/fi';
import { getImagenUrl } from 'shared/api';

const S = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 3000,
  },
  modal: {
    backgroundColor: 'var(--agx-surface)',
    borderRadius: '12px',
    padding: '16px',
    maxWidth: '90vw',
    maxHeight: '90vh',
    position: 'relative',
    boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
  },
  closeBtn: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: 'none',
    background: 'rgba(0,0,0,0.5)',
    color: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    zIndex: 1,
  },
  img: {
    maxWidth: '100%',
    maxHeight: 'calc(90vh - 32px)',
    display: 'block',
    borderRadius: '8px',
  },
};

export default function VisorComprobante({ comprobanteUrl, onClose }) {
  if (!comprobanteUrl) return null;

  const url = comprobanteUrl.startsWith('http') ? comprobanteUrl : getImagenUrl(comprobanteUrl);

  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={(e) => e.stopPropagation()}>
        <button style={S.closeBtn} onClick={onClose}>
          <FiX size={18} />
        </button>
        <img src={url} alt="Comprobante" style={S.img} />
      </div>
    </div>
  );
}
